<udex-button
  *ngIf="displayProduct"
  class="udex-mt-20"
  size="Large"
  design="Primary"
  (click)="redirectToProduct()"
>{{buttonText | cxTranslate}}</udex-button>
